@let branding = brandingService.branding$ | async;

@if (branding !== undefined && branding !== null) {
<div class="mm-learn">
    <div class="mm-auth-error" >
        <span class="mm-error-message">{{'general.missingRole' | translate:{appName: branding.appName} }}</span>
        <button class="mm-login-button" (click)="logout()">{{'general.missingRoleButton' | translate}}</button>
    </div>
</div>
}
